
export const fetchPodcastId = (imageUrl, podcastLink) => {
    try {
        var urlSplits = imageUrl.split("podcast/");
        if (urlSplits.length > 1) {
            return urlSplits[1].split("/")[0];
        }
        const podcastLinkSplit = (podcastLink ?? "0/0").split("/")
        const podcastId = podcastLinkSplit[podcastLinkSplit.length - 1]
        return podcastId
    } catch (e) {
        return ''
    }
}